module.exports = __webpack_public_path__ + "img/logo-magazine-mobile.45370cd.png";